/* FeaturedSection.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _12 = "@media (min-width:64rem){._dm2511p5{display:grid}._1rqt16hb{grid-template-columns:repeat(3,1fr)}._pdlmhiv4{gap:var(--ds-space-400)}._1hvkidpf{margin-right:0}._1rmjidpf{padding-right:0}._zp81ewfl{overflow-x:visible}}";
const _11 = "@media (min-width:48rem) and (max-width:63.99rem){._1gzvl6l0{gap:var(--ds-space-300)}._1lh7hiv4{padding-right:var(--ds-space-400)}._d97midpf{margin-right:0}}";
const _10 = "._18s8jjia{margin:var(--ds-space-negative-400) 0 var(--ds-space-negative-400) var(--ds-space-negative-300)}";
const _9 = "._1yt41yaq{padding:var(--ds-space-400) var(--ds-space-300) var(--ds-space-400) var(--ds-space-300)}";
const _8 = "._1reo1wug{overflow-x:auto}";
const _7 = "._zulpxjmg{gap:var(--ds-space-200)}";
const _6 = "._1e0c1txw{display:flex}";
const _5 = "@media (min-width:64rem){._isu4hiv4{margin-bottom:var(--ds-space-400)}}";
const _4 = "@media (min-width:48rem) and (max-width:63.99rem){._1b7el6l0{margin-bottom:var(--ds-space-300)}}";
const _3 = "._otyrxjmg{margin-bottom:var(--ds-space-200)}";
import { media } from '@atlaskit/primitives/responsive';
import { BodyLarge, H3 } from '@atlassian/mpac-primitives';
import React from 'react';
import { collections } from './constants';
import { FeaturedCard } from './FeaturedCard';
const _2 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _ = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
const Description = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pk1b66 _syaz1k3w", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
const SectionHeader = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4, _5]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_otyrxjmg _1b7el6l0 _isu4hiv4", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SectionHeader.displayName = 'SectionHeader';
}
const CardsWrapper = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_6, _7, _8, _9, _10, _11, _12]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _zulpxjmg _1reo1wug _1yt41yaq _18s8jjia _1gzvl6l0 _1lh7hiv4 _d97midpf _dm2511p5 _1rqt16hb _pdlmhiv4 _1hvkidpf _1rmjidpf _zp81ewfl", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  CardsWrapper.displayName = 'CardsWrapper';
}
export const FeaturedSection = () => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(H3, {
    as: "h2"
  }, "Featured collections"), /*#__PURE__*/React.createElement(Description, null, "Experience and engage with our curated assortment of apps")), /*#__PURE__*/React.createElement(CardsWrapper, null, collections.map(collection => {
    const {
      id,
      title,
      description,
      image,
      backgroundColor
    } = collection;
    return /*#__PURE__*/React.createElement(FeaturedCard, {
      key: id,
      title: title,
      description: description,
      image: image,
      backgroundColor: backgroundColor,
      navigationUrl: "/collections/".concat(id),
      ariaHidden: true
    });
  })));
};